export const getAccountImportSettingFormConfig = (defaultAccountFieldTypeValues, settingDestinationFieldExclusions, settingLengthFieldInclusions, additionalWidgetConfigTypes) => {
    return {
        type: 'form',
        children: [
            {
                type: 'form.dataGrid',
                addButtonLabel: 'Add Field',
                reorder: true,
                children: [
                    {
                        type: 'form.panel',
                        children: [
                            {
                                type: 'form.panel',
                                children: [
                                    {
                                        type: 'form.text',
                                        key: 'headerName',
                                        label: 'Header Name',
                                        validate: {
                                            required: true,
                                        },
                                    },
                                    {
                                        type: 'form.text',
                                        key: 'destination',
                                        label: 'Destination',
                                        hidden: {
                                            when: '^^/type',
                                            dataIn: settingDestinationFieldExclusions !== null && settingDestinationFieldExclusions !== void 0 ? settingDestinationFieldExclusions : [],
                                        },
                                    },
                                ],
                                style: {
                                    layout: 'row',
                                    horizontalAlign: 'left',
                                },
                            },
                            {
                                type: 'form.select',
                                key: 'type',
                                label: 'Type',
                                validate: {
                                    required: true,
                                },
                                values: defaultAccountFieldTypeValues,
                            },
                            {
                                type: 'form.text',
                                key: 'exampleValue',
                                label: 'Example Value',
                            },
                            {
                                type: 'form.panel',
                                children: [
                                    {
                                        type: 'form.number',
                                        key: 'length',
                                        label: 'Field Length',
                                        hidden: {
                                            when: '^^/type',
                                            dataNotIn: settingLengthFieldInclusions !== null && settingLengthFieldInclusions !== void 0 ? settingLengthFieldInclusions : [],
                                        },
                                    },
                                    {
                                        type: 'form.checkbox',
                                        key: 'required',
                                        label: 'Required',
                                    },
                                ],
                                style: {
                                    layout: 'row',
                                    horizontalAlign: 'left',
                                    verticalAlign: 'center',
                                },
                            },
                            ...(additionalWidgetConfigTypes || []),
                            {
                                type: 'form.divider',
                            },
                        ],
                    },
                ],
            },
        ],
    };
};
